module.exports = {
      id: "share-greybg-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite-bc5ff1507898764e0c54e53c34039c01.svg#share-greybg",
      toString: function () {
        return this.url;
      }
    }